import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

const ObjectiveSelectorRoute = lazyRouteComponent(
  () => import('@/features/objective-selector/ObjectiveSelector'),
  'ObjectiveSelector'
)

export const Route = createFileRoute('/objetivo')({
  component: ObjectiveSelectorRoute,
})
